import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Symptoms: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-symptoms-blue-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            className="w-14 h-12 fill-white"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                        >
                            <path d="M515.6 227.6h-21.55c-50.68 0-76.06-61.28-40.23-97.12l15.25-15.25c11.11-11.11 11.11-29.11 .001-40.22c-11.11-11.11-29.11-11.11-40.22 .001l-15.24 15.24c-35.84 35.84-97.12 10.46-97.12-40.23V28.44c0-15.72-12.72-28.44-28.45-28.44S259.6 12.72 259.6 28.44v21.55c0 50.68-61.28 76.06-97.12 40.23L147.2 74.97C136.1 63.86 118.1 63.86 106.1 74.97c-11.11 11.11-11.11 29.11 .001 40.22l15.25 15.25C158.1 166.3 132.7 227.6 81.99 227.6H60.45C44.72 227.6 32 240.3 32 256s12.72 28.44 28.45 28.44h21.55c50.68 0 76.06 61.28 40.23 97.12l-15.25 15.25c-11.11 11.11-11.11 29.11-.001 40.22c5.555 5.555 12.83 8.333 20.11 8.333c7.277 0 14.55-2.779 20.11-8.334l15.24-15.25c35.84-35.84 97.12-10.46 97.12 40.23v21.55c0 15.72 12.72 28.45 28.45 28.45s28.45-12.72 28.45-28.45v-21.55c0-50.68 61.28-76.06 97.12-40.23l15.24 15.25c5.557 5.555 12.83 8.334 20.11 8.334c7.279 0 14.56-2.778 20.11-8.333c11.11-11.11 11.11-29.11-.001-40.22l-15.25-15.25c-35.84-35.84-10.46-97.12 40.23-97.12h21.55C531.3 284.4 544 271.7 544 256S531.3 227.6 515.6 227.6zM256 272c-26.51 0-48-21.49-48-48s21.49-48 48-48s48 21.49 48 48S282.5 272 256 272zM336 328c-13.25 0-24-10.75-24-24c0-13.26 10.75-23.1 24-23.1s24 10.74 24 24C360 317.3 349.3 328 336 328z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">{sectionName || 'Symptoms'}</div>} key="1">
                <p className="mr-16 space-y-2">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    symptoms_name_in_capital: !rxConfig?.symptoms_name_in_capital,
                                });
                            }}
                        >
                            <span>Capitalize name</span>
                            <Checkbox checked={rxConfig?.symptoms_name_in_capital}></Checkbox>
                        </p>
                    </div>

                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    symptoms_name_in_unbold: !rxConfig?.symptoms_name_in_unbold,
                                });
                            }}
                        >
                            <span>Make the chief complaints name bold</span>
                            <Checkbox checked={!rxConfig?.symptoms_name_in_unbold}></Checkbox>
                        </p>
                    </div>

                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['symptoms']: !rxConfig?.bullets_config?.['symptoms'],
                                    },
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox checked={rxConfig?.bullets_config?.['symptoms']}></Checkbox>
                        </p>
                    </div>

                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.symptoms_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        symptoms_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            symptoms_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Key Elements</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.symptoms_name_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        symptoms_name_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            symptoms_name_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.symptoms_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        symptoms_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            symptoms_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
            <style>
                {`
                    .circular-color-input {
                        width: 20px; /* Adjust the width as needed */
                        height: 20px; /* Adjust the height as needed */
                        border-radius: 50%;
                        border: none; /* Remove default border */
                        padding: 0;
                        appearance: none; /* Remove default styling */
                        -webkit-appearance: none; /* Remove default styling in Safari */
                        cursor: pointer; /* Change cursor to pointer */
                        overflow: hidden; /* Ensure color doesn't overflow */
                    }
                    
                    .circular-color-input::-webkit-color-swatch-wrapper {
                        padding: 0;
                        border-radius: 50%; /* Ensure the swatch itself is circular */
                    }
                    
                    .circular-color-input::-webkit-color-swatch {
                        border: none;
                        border-radius: 50%;
                        padding: 0;
                    }
                    
                    .circular-color-input::-moz-color-swatch {
                        border: none;
                        border-radius: 50%;
                    }
                    `}
            </style>
        </Collapse>
    );
};

export default Symptoms;
